import { constructionAsset, constructionEquipment, constructionSafety } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: 'Bạn có biết, mỗi khi nhắc đến an ninh và giám sát, hầu hết chúng ta đều nghĩ đến camera. Nhưng hệ thống CCTV đã tiến hóa rất nhiều so với camera truyền thống. Trong thời đại Internet of Things (IoT) và Edge Computing, CCTV không chỉ ghi hình mà còn trở thành giải pháp công nghệ cao, giúp doanh nghiệp, tổ chức quản lý an ninh, tối ưu khai thác dữ liệu và tích hợp sâu trong hạ tầng IT. Hãy cùng ORBRO tìm hiểu CCTV là gì, phân loại và vai trò đa chiều của nó trong cuộc sống hiện đại.',
  keywords: 'cctv, cctv là gì, phân loại cctv, vai trò cctv, cctv an ninh, cctv giám sát',
  ogSite: 'CCTV là gì? Phân loại và vai trò trong kỷ nguyên số',
  title: 'CCTV là gì? Phân loại và vai trò trong kỷ nguyên số',
  ogUrl: 'https://orbro.io/vi/blog/cctv-la-gi-phan-loai-va-vai-tro',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_HQL0uLdowBG1C-9w9Mxz9ISOcp8CHof4GzNDRmJUN7yRblaDArwg5ymJVi6wTACN0tDPCLfmwuA23NKXo8ud7uUsiHlFuIkNtWrtT0xprdpn7KzkPdKb3cNuJI11TIE6iu-qaxfwghPhDVFItxJhbw4PQlG7RtMhmg_tybRtaLD5M2rDYokR6IxRbwU-CxeczVMb7I5fUrc90sTlWht7z3jmNZmnLUZc7MIJiPfMxpprEx19DhPOYUDKZrhFB5GSdUi9AhU2VguKbpPXMiXBWfM4BHZB7ugFfGCwzgaj2UqFyPRBBY9lGrpIvsmSa_np4ZqQAJWWGAqftTcyHSlU4nTCcM6cYgNdSWzlVjDxqdz_GpJs1hhU1q0IVrYPLOG8fo2JCh2UxC2tAxJYy_tjI-zjh0Hu97GogBk6nSVSG024v1rqAG3rZJOhk2BwVF6-1a2gTGCrv6lxn1WYLJIACOeh2koUGhXcPJbEUPcV8eq_S06DskK18rj1SsMK0nF7HHE6AirUDGl6tKmTmYDNFrn6KEYy5p9WMdi04M2IaoyCBuHnyftjpyC-HN6Lr3a0f479zS8GFaTGT4wdbBAC_WP4xho2d0QDkoqtWypHkDVQy2hrQxj5aEng0yddVf2hELf2WdFaJAdRfTl92VQ-0ql76cmPQfSq8z8Gbeb18yywOGlCHmdIE-QKNTv-hSZ8COxflykHi41c6-UVJONtZXVnASw_83MxtQ-e91EmstTIp0F9j7Y248xg-HXcLWa1-r8JRi2eUDcLwz2QQk39gng0MRpe0hPzOg8HLYO9QHu_LoX3HvUZw2afF0FUIcjmiL9wRkvdgIwjHcggmTaEAB48Gmde_JNfcL_JgebsETRc9HgA5INv9l9aqHE6dibjROAqZyCxp3PCzCThkQMSG201XzB-o_rwRqGUDOTx8or2EgggpLHH5cB_Ev2hDvTXKSYkADuSa1gzXl7sxV39PO5lhBVAzR6bUBjfTpQ1N7gNLEAInqjLJmadCSL04XZmo3gOtxRpEn33y2U8jj0rWUTmB3HhYtm7GtE4pPU6Bm78lc9JVA2GGuHwNTFuHhw8o5nQ4NXJa11N1ggNqVsGN6wRNTMC9aj7yJ77HF1c7wkLSw80RI83RMuixfWeq5X2by-z880c2_wEN3ZvVdoGJKPNj1uxMh-3pp820q8jE-L-79ADKJxME9SBeZLYvp8Os2lqF8wr6PNtytmdhHz5McqTAOVlzQJyTDWk4kO1X7WVmHLCYfvfnpUhkuk1l-OfDRbWhsB7G1Cdcw_YtKDNezSqTstWBXlc21Q6_iFrX5W134mrnJm0j682HrOxK-CXQwFCqO-GM1cUd6QW5OcOh5B-3i1NVQmWR_7EHyXbMHLDh2j53vqZb613IY2QdqDFQjzXFXLsUfAF8KPS8RSxFTUMpqJh50NTDOw02oEBFU3n6UqbX9pQL3IvlpcLWwb6NE15FMckPS2pWB7Wyrc9irP57_4myIhzxno_E8tmIgZ3ZGVQUTwcXmF3vjzHAX58XSSiUUOo6gjwRlqNMPEGKWx6ckQnhoHkVL4hOnDZkDEFxmeR4X8uB-w8gZB-6hkgES26d8HnWHreo_Q8f7_IPn7M8bMV-pMKydJQ=w1430-h1412?auditContext=forDisplay',
  ogType: 'website',
  date: '2025-07-08',
  tag1: '#cctv',
  tag2: '#cctvanninh',
  tag3: '#cctvgiamsat',
  tag4: '#cameraanninh',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Bạn có biết, mỗi khi nhắc đến an ninh và giám sát, hầu hết chúng ta đều nghĩ đến camera. Nhưng hệ thống CCTV đã tiến hóa rất nhiều so với camera truyền thống. Trong thời đại Internet of Things (IoT) và Edge Computing, CCTV không chỉ ghi hình mà còn trở thành giải pháp công nghệ cao, giúp doanh nghiệp, tổ chức quản lý an ninh, tối ưu khai thác dữ liệu và tích hợp sâu trong hạ tầng IT. Hãy cùng ORBRO tìm hiểu CCTV là gì, phân loại và vai trò đa chiều của nó trong cuộc sống hiện đại.',
      dot: ''
    },
    {
      head: '1. CCTV là gì?',
      subHead: '',
      desc: 'CCTV (Closed-Circuit Television), hay truyền hình mạch kín, là hệ thống camera và thiết bị ghi hình hoạt động trong một mạng nội bộ, không phát sóng công khai. Thay vì truyền tín hiệu ra không gian rộng lớn, CCTV giới hạn việc truyền video giữa camera, đầu ghi (DVR/NVR) và màn hình hoặc phần mềm quản lý, đảm bảo tính bảo mật và tập trung.\n\nBản chất của CCTV ngày nay là một hệ sinh thái bao gồm:\n\n• Camera IP/Analog: Ghi hình ở nhiều độ phân giải, hỗ trợ IR, PTZ và AI onboard.\n\n• Đầu ghi DVR/NVR: Ghi hình, mã hóa, lưu trữ và truyền dữ liệu.\n\n• Hạ tầng mạng: Dây cáp (coax/ethernet) hoặc Wi-Fi, 5G đảm bảo kết nối.\n\n• Phần mềm/VMS (Video Management System): Trung tâm giám sát, phân tích, cảnh báo và quản lý người dùng.',
      dot: ''
    },
    {
      head: '2. Phân loại CCTV hiện đại',
      subHead: 'Theo chuẩn kết nối',
      desc: 'Analog CCTV: Dùng cáp đồng trục, kết hợp DVR, chi phí thấp nhưng hạn chế về độ phân giải.\n\nIP CCTV: Dùng mạng LAN/Wi-Fi, camera số hóa truyền tín hiệu tới NVR hoặc cloud, mở rộng linh hoạt.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Theo tính năng thông minh',
      desc: 'Camera AI: Nhận diện khuôn mặt, phát hiện chuyển động bất thường, đếm người.\n\nCamera HDR/WDR: Xử lý khung hình ngược sáng, đảm bảo chi tiết trong mọi điều kiện ánh sáng.\n\nCamera an ninh chuyên dụng: Chống va đập, chống nước (IP66/IP67) cho môi trường khắc nghiệt.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Theo cách triển khai',
      desc: 'On-premise CCTV: Lắp đặt tại chỗ, dữ liệu lưu trên đầu ghi/NAS, thích hợp nơi cần kiểm soát chặt.\n\nCloud CCTV: Camera kết nối internet, lưu trữ và phân tích video trên đám mây, hỗ trợ remote access mọi lúc mọi nơi.\n\nEdge CCTV: Xử lý AI ngay tại camera hoặc gateway biên (edge device), giảm tải băng thông và độ trễ.',
      dot: ''
    },
    {
      head: '3. Vai trò của CCTV trong CNTT và đời sống',
      subHead: 'An ninh mạng và vật lý tích hợp',
      desc: 'Trong môi trường doanh nghiệp, CCTV ngày càng tích hợp API với hệ thống SIEM (Security Information and Event Management) và Access Control. Khi camera AI phát hiện xâm nhập hoặc hành vi lạ, sự kiện được ghi vào log bảo mật, cảnh báo SOC team đồng thời khóa cửa tự động.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Giám sát IoT và thiết bị thông minh',
      desc: 'CCTV kết nối với IoT hub để giám sát máy móc, dây chuyền sản xuất. Camera quan sát rung động, nhiệt độ bất thường, kích hoạt tự động dừng máy hoặc gửi cảnh báo qua MQTT và webhook.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Phân tích video và Big Data',
      desc: 'Hệ thống VMS hiện đại thu thập metadata từ video (ví dụ: thời gian, vị trí, chuyển động, số người), đưa vào Big Data để phân tích heatmap, dự báo lưu lượng khách hàng, tối ưu bố trí không gian bán lẻ hoặc sản xuất.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Ứng dụng đô thị thông minh',
      desc: 'CCTV được lắp trên đèn đường, cầu, trụ sở công cộng để theo dõi giao thông, đếm xe, phát hiện ùn tắc và tự điều chỉnh đèn tín hiệu. Dữ liệu còn được chia sẻ với người dân qua app mobile và bảng điện tử công cộng.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Chăm sóc sức khỏe và y tế từ xa',
      desc: 'Bệnh viện gắn camera cho phòng bệnh nhân, kết hợp AI phân tích chuyển động, phát hiện ngã hoặc các dấu hiệu nguy hiểm. Hình ảnh mã hóa và tuân thủ HIPAA/GDPR giúp bảo vệ quyền riêng tư.',
      dot: ''
    },
    {
      head: '4. Lợi ích khi triển khai CCTV thông minh',
      subHead: '',
      desc: '• Tăng cường an ninh đa lớp: Bảo mật vật lý và mạng tích hợp, răn đe tội phạm.\n\n• Giám sát từ xa hiệu quả: Mọi sự kiện, video đều có thể truy cập trên điện thoại hoặc web app.\n\n• Tối ưu hạ tầng và chi phí: Edge computing giảm băng thông, cloud storage linh hoạt.\n\n• Phân tích thông minh: AI và Big Data cung cấp insight cho marketing, vận hành.\n\n• Tuân thủ tiêu chuẩn: Dễ dàng đáp ứng ISO 27001, GDPR, PCI DSS khi lưu trữ và mã hóa video.',
      dot: ''
    },
    {
      head: '5. Kết luận',
      subHead: '',
      desc: 'Thế giới đã bước vào kỷ nguyên số hóa, nơi CCTV không chỉ đơn thuần là camera ghi hình mà đã trở thành phần quan trọng của hạ tầng IT – tích hợp với IoT, AI, Edge và Cloud. Việc triển khai CCTV thông minh giúp doanh nghiệp nâng cao an ninh, tối ưu vận hành và khai thác dữ liệu sâu sắc hơn. Hãy bắt đầu cùng ORBRO lựa chọn giải pháp phù hợp để không bỏ lỡ cơ hội tăng trưởng và phát triển bền vững trong kỷ nguyên 4.0!',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionEquipment.thumb,
        data: 'constructionEquipment',
        link: '/vi/enterprise/construction/equipment',
      },
    ],
  },
};
